module.exports = "//public.getcloudapp.com/packs/media/images/coach-mark-67a398ec39df9e808b3e0ed939e06be4.svg";